import { normalizeText } from "./text";
import { Place, WithId } from "./types";

/**
 * Encontra um local pelo nome ou apelido. Ordem: igualdade exata, começa com,
 * contém. Sempre ignora acentos e caixa. Só considera locais ativos.
 */
export function resolvePlace(
  text: string | undefined,
  places: WithId<Place>[]
): WithId<Place> | undefined {
  const query = normalizeText(text);
  if (!query) return undefined;

  const active = places.filter((p) => p.active);
  const candidates = active.map((place) => ({
    place,
    keys: [place.name, ...(place.aliases || [])].map(normalizeText).filter(Boolean),
  }));

  const exact = candidates.find((c) => c.keys.includes(query));
  if (exact) return exact.place;

  const starts = candidates.find((c) => c.keys.some((k) => k.startsWith(query)));
  if (starts) return starts.place;

  const includes = candidates.find((c) => c.keys.some((k) => k.includes(query)));
  return includes?.place;
}

/** Filtra locais para o combobox (busca por nome, apelido ou região). */
export function searchPlaces(
  query: string,
  places: WithId<Place>[],
  zoneNames: Record<string, string> = {}
): WithId<Place>[] {
  const q = normalizeText(query);
  const active = places.filter((p) => p.active);
  if (!q) return active;
  return active.filter((place) => {
    const keys = [place.name, ...(place.aliases || []), zoneNames[place.zoneId] || ""];
    return keys.some((k) => normalizeText(k).includes(q));
  });
}
